import React from 'react'
import DistChart from './ChartComponents/Distribution'
import PropTypes from 'prop-types'
import List from '../../../components/List'
import DownCarot from '../../../assets/icons/carat.svg'

class Cognition extends React.Component {
  constructor (props) {
    super(props)
    this.VocabularyData = this.VocabularyData.bind(this)
    this.AttentionData = this.AttentionData.bind(this)
    this.FlexibilityData = this.FlexibilityData.bind(this)
    this.ProcessingData = this.ProcessingData.bind(this)
    this.EpisodeData = this.EpisodeData.bind(this)

    // getinitialState
    this.state = {
      vocabulary: this.VocabularyData(),
      attention: this.AttentionData(),
      flexibility: this.FlexibilityData(),
      processing: this.ProcessingData(),
      episode: this.EpisodeData()
    }
  }

  VocabularyData () {
    const { details } = this.props
    let stats = details.vocabulary

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  AttentionData () {
    const { details } = this.props
    let stats = details.attention

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  FlexibilityData () {
    const { details } = this.props
    let stats = details.flexibility

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  ProcessingData () {
    const { details } = this.props
    let stats = details.processing_speed

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  EpisodeData () {
    const { details } = this.props
    let stats = details.episodic_memory

    return {
      display_label: stats.display_label,
      unit: stats.unit,
      value: stats.value,
      interpretation: stats.interpretation,
      percentile: stats.percentile,
      ranges: stats.ranges,
      test_name: stats.test_name,
      density_plot: stats.density_plot
    }
  }

  render () {
    const { index, details, hotload } = this.props

    const items = {
      physicalActivity: {
        title: '<h2 class="mobile-padding">Cognition</h2>',
        icon: { src: DownCarot },
        isShowAccordianOnMobile: true,
        accordianContent: `
      <div class="mobile-padding">
            <div>
              <p class="noMarginPadding">
              Cognition is the mental action or process of acquiring knowledge and
            understanding through thought, experience, and the senses. Lab100
            assesses five cognitive domains.
              </p>
            </div>
              <br/>
          </div>`
      }
    }
    const listProps = {
      items,
      isMobile: this.props.isMobile,
      isNoTopBorder: true,
      isNotSpacer: true,
      isCollapsedDark: true,
      isReportStyle: true
    }

    return (
      <div className="cognition-content module-content">
        <div className="intro-zone">
          {this.props.isMobile ? (
            <List {...listProps} />
          ) : (
            <p>
              Cognition is the mental action or process of acquiring knowledge
              and understanding through thought, experience, and the senses.
              Lab100 assesses five cognitive domains.
            </p>
          )}
        </div>
        {!this.props.isMobile && <hr />}
        {hotload ? (
          <div className="mobile-padding">
            <div className="bucket">
              <div className="table">
                <div className="trow vocab">
                  <div className="td even-width">
                    <strong className="subject">
                      {details.vocabulary.display_label}
                    </strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.vocabulary.value}
                    </strong>
                    <span className="descriptor">T-Score</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.vocabulary.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'Vocabulary'}
                      details={details}
                      index={index}
                      data={this.state.vocabulary}
                    />
                  </div>
                </div>
              </div>

              <p>
                Vocabulary is a strong measure of crystalized abilities — those
                abilities that are more dependent upon past learning experiences
                and are relatively consistent across the adult life span.
              </p>

              {!details.attention.__ok ? (
                <div className="no-report-data">
                  {`No ${details.attention.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            <hr />

            <div className="bucket">
              <div className="table">
                <div className="trow attention">
                  <div className="td even-width">
                    <strong className="subject">
                      {details.attention.display_label}
                    </strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">{details.attention.value}</strong>
                    <span className="descriptor">T-Score</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.attention.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'Attention'}
                      details={details}
                      index={index}
                      data={this.state.attention}
                    />
                  </div>
                </div>
              </div>

              <p>
                Attention or ‘executive function’ represents capacity for new
                learning and information processing in novel situations. It is a
                fluid ability which reaches a peak in early adulthood, then
                tends to decline across the life span (dependent on health and
                individual factors).
              </p>

              {!details.attention.__ok ? (
                <div className="no-report-data">
                  {`No ${details.attention.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            <hr />

            <div className="bucket">
              <div className="table">
                <div className="trow flexibility">
                  <div className="td even-width">
                    <strong className="subject">
                      {details.flexibility.display_label}
                    </strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.flexibility.value}
                    </strong>
                    <span className="descriptor">T-Score</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.flexibility.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'Flexibility'}
                      details={details}
                      index={index}
                      data={this.state.flexibility}
                    />
                  </div>
                </div>
              </div>

              <p>
                Cognitive flexibility is the ability to switch between thinking
                about two different concepts, and to think about multiple
                concepts simultaneously. It is a fluid ability which reaches a
                peak in early adulthood, then tends to decline across the life
                span (dependent on health and individual factors).
              </p>

              {!details.flexibility.__ok ? (
                <div className="no-report-data">
                  {`No ${details.flexibility.display_label} Data Available`}
                </div>
              ) : null}
            </div>
            <hr />

            <div className="bucket">
              <div className="table">
                <div className="trow processing">
                  <div className="td even-width">
                    <strong className="subject">
                      {details.processing_speed.display_label}
                    </strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.processing_speed.value}
                    </strong>
                    <span className="descriptor">T-Score</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.processing_speed.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'Processing'}
                      details={details}
                      index={index}
                      data={this.state.processing}
                    />
                  </div>
                </div>
              </div>

              <p>
                Processing speed reflects the time taken to perform mental
                tasks. It is a fluid ability which reaches a peak in early
                adulthood, then tends to decline across the life span (dependent
                on health and individual factors).
              </p>

              {!details.processing_speed.__ok ? (
                <div className="no-report-data">
                  {`No ${
                    details.processing_speed.display_label
                  } Data Available`}
                </div>
              ) : null}
            </div>
            <hr />

            <div className="bucket">
              <div className="table">
                <div className="trow episodic_memory">
                  <div className="td even-width">
                    <strong className="subject">
                      {details.episodic_memory.display_label}
                    </strong>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.episodic_memory.value}
                    </strong>
                    <span className="descriptor">T-Score</span>
                  </div>
                  <div className="td even-width">
                    <strong className="value">
                      {details.episodic_memory.percentile}%
                    </strong>
                    <span className="descriptor">Percentile</span>
                  </div>
                  <div className="td">
                    <DistChart
                      label={'Episode'}
                      details={details}
                      index={index}
                      data={this.state.episode}
                    />
                  </div>
                </div>
              </div>

              <p>
                Episodic memory represents the acquisition, storage and recall
                of new information. It is a fluid ability which reaches a peak
                in early adulthood, then tends to decline across the life span
                (dependent on health and individual factors).
              </p>
              {!details.episodic_memory.__ok ? (
                <div className="no-report-data">
                  {`No ${details.episodic_memory.display_label} Data Available`}
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

Cognition.propTypes = {
  details: PropTypes.object.isRequired
}

export default Cognition
